module.exports = "<div class=\"checkbox p-xs\" [ngClass]=\"{ 'd-inline' : inline}\" >\n  <label class=\"d-flex align-items-center\">\n    <ng-content>\n    </ng-content>\n    <span class=\"pl-1\">\n      {{ label }}\n    </span>\n  </label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/core/checkbox/checkbox.component.html
// module id = 1091
// module chunks = 0